import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const arjTimelineEmbedRoute: InvariantJiraRoute = {
	name: 'software-advanced-roadmaps-embed',
	path: '/jira/plans/:planId/scenarios/:scenarioId/timeline/embed',
};
